import { Alert, AlertTitle } from '@mui/material'
import React from 'react'

const AddressOcrErrorMessage = ({ ocrErrorCode }) => {
  const OCR_ERROR_CODES = {
    TOO_MANY_ATTEMPTS: 'TooManyAddressOcrAttemptsError',
  }
  const tooManyAttemotsErrorMessage = () => (
    <p>
      Você atingiu o limite de tentativas de validação.
      <br></br>
      Para prosseguir, considere marcar a caixa abaixo.
    </p>
  )

  const genericErrorMessage = () => <p>Um erro inesperado ocorreu. Por favor, tente novamente.</p>

  const buildMessage = () => {
    switch (ocrErrorCode) {
      case OCR_ERROR_CODES.TOO_MANY_ATTEMPTS:
        return tooManyAttemotsErrorMessage()
      default:
        return genericErrorMessage()
    }
  }
  return (
    <Alert severity="warning" color="error">
      <AlertTitle>Não foi possível validar seu arquivo de comprovante de residência.</AlertTitle>
      {buildMessage()}
    </Alert>
  )
}

export default AddressOcrErrorMessage
